import React from 'react'
import {authRoles} from '../../auth/authRoles'

const DataDashboardRoutes = [
    {
        path: '/dashboard/',
        component: React.lazy(() => import('./Dashboard')),
        auth: authRoles.myprofile,
    },
]

export default DataDashboardRoutes